<template>
  <div class="form">
    <span class="title">{{ $t("views.custom_resource.name") }}</span>
    <span class="sec-description">{{ $t("views.custom_resource.description") }}</span>

     <v-container class="content" grid-list-xl>
        <v-layout wrap>

          <v-flex md12 align-center>
            <v-textarea auto-grow rows="1" v-model="topic" :label="$t('views.custom_resource.matter')"></v-textarea>
          </v-flex>

          <v-flex md12 align-center>
            <v-textarea auto-grow rows="3" v-model="comments" row-height="30" :label="$t('views.custom_resource.comments')"></v-textarea>
          </v-flex>

          <div class="button submit" @click="sendMail()">{{ $t("views.custom_resource.request") }}</div>

      </v-layout>
    </v-container>

  </div>
</template>

<script>
import i18n from "@/i18n";
import {Api} from '@/core/api.js';
const api = new Api();

export default {
  name: 'CustomResource',
 
  data () {
    return {
      topic: "",
      comments: "",
    }
  },
  computed: {
    selectedLocation () {
      return this.$store.getters['locations/getSelectedLocation'];
    },
  },
  methods: {
    sendMail() {
      if(this.topic!="") {
        this.$overlay.loading();
        var self = this;
        api.post( 'resource/custom/mail', { topic: this.topic, comments: this.comments, restaurant_name: this.selectedLocation.name, restaurant_site: this.selectedLocation.site } ).then( function( response ){
          self.$overlay.hide();
          self.$popup.alert(
          self.$t("views.custom_resource.success"),
          function(){
          });
        });
      }
    }
  },
  watch: {
  },
  created() {
    this.$store.commit('setTitle', this.$t("views.custom_resource.name"));
    this.$store.commit('setMenuVisible', false);
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .form {
    height: 80vh;
   
    .content {
      max-width: 900px;
      margin: 0 auto;
      margin-top: 75px;
    }

    .title {
      display: block;
      margin-top: 30px;
      margin-bottom: 10px;
    }

    .submit {
      padding: 10px 50px;
      background-color: var(--main_color);
      margin: 30px auto;
      font-size: 16px;
      cursor: pointer;
    }
  }
  


</style>